import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TableHead,
  CircularProgress,
  Box,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Chip,
} from "@mui/material";
import Iconify from "../components/iconify";
import Scrollbar from "../components/scrollbar";
import { useNavigate, useSearchParams } from "react-router-dom";
import { get, post } from "src/utils/networkUtils";

export default function GameResultsPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(null);
  const [openId, setOpenId] = useState(null);
  const [rows, setRows] = useState(null);
  const [game, setGame] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    if (searchParams.has("game_id")) {
      let gameId = searchParams.get("game_id");
      get(`/admin/game/${gameId}/results`).then(function (response) {
        setRows(response.results);
      });
      get(`/admin/games/${gameId}`).then(function (response) {
        setGame(response.game);
      });
    } else {
      navigate("/404");
    }
  }, [setSearchParams, searchParams, navigate]);

  const handleGenerateGameCards = () => {
    setLoading(true);

    post(`/admin/game/${game.gameId}/generate-results`)
      .then(function (response) {
        window.location.reload(false);
      })
      .catch(function (error) {
        setErrorMessage(error.response.error);
        setLoading(false);
      });
  };
  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
    setOpenId(event.currentTarget.id);
  };

  const handleCloseMenu = () => {
    setOpen(null);
    setOpenId(null);
  };
  return (
    <>
      <Helmet>
        <title> Bingo Game Results </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Game Results
          </Typography>
          {true && (
            <Button
              variant="contained"
              startIcon={<Iconify icon="eva:flip-2-outline" />}
              onClick={() => handleGenerateGameCards()}
              disabled={loading}
            >
              Generate Results
            </Button>
          )}
        </Stack>
        {game !== null ? (
          <>
            <Alert sx={{ marginBottom: 2 }} severity="info">
              {`Generated results: ${game.usersWithResultsCount} / ${game.allUsersCount}`}
            </Alert>
          </>
        ) : null}

        <Card>
          {rows === null || loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Scrollbar>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>User ID</TableCell>
                      <TableCell>Username</TableCell>
                      <TableCell>Entries</TableCell>
                      <TableCell size="small">Details</TableCell>
                      <TableCell align="right"></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {row.userId}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.username}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.entriesCount}
                        </TableCell>
                        <TableCell component="th" scope="row" size="small">
                          {Object.keys(row.scoreDetails).map((property) => (
                            <Chip
                              label={`${property}: ${row.scoreDetails[property]}`}
                            />
                          ))}
                        </TableCell>

                        <TableCell align="right">
                          <IconButton
                            size="large"
                            color="inherit"
                            onClick={handleOpenMenu}
                            id={row.userId}
                          >
                            <Iconify icon={"eva:more-vertical-fill"} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          )}
        </Card>
      </Container>

      <Dialog
        open={errorMessage !== null}
        onClose={() => setErrorMessage(null)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">ERROR</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {errorMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setErrorMessage(null)}>OK</Button>
        </DialogActions>
      </Dialog>
      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            "& .MuiMenuItem-root": {
              px: 1,
              typography: "body2",
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem
          onClick={() =>
            navigate(
              `/dashboard/game/user-card?game_id=${game.gameId}&user_id=${openId}`
            )
          }
        >
          <Iconify icon={"eva:keypad-outline"} sx={{ mr: 2 }} />
          Game Card
        </MenuItem>
      </Popover>
    </>
  );
}
